import { Pagination } from "./components/Table/Table";

/**
 * Default page size used in tables
 */
export const DEFAULT_PAGE_SIZE = 50;

export const DEFAULT_PAGINATION: Pagination = {
  page: 1,
  pageSize: 20,
};

export const COGNITO_USER_POOL_ID =
  process.env.REACT_APP_COGNITO_POOL_ID || "eu-central-1_Y88WiERsG";
export const COGNITO_CLIENT_ID =
  process.env.REACT_APP_COGNITO_CLIENT_ID || "19pedaah0canjbgkhi5fooaqh7";
